import { Nullable } from 'cng-common/models/utils'

interface ICalculateSalesPerformanceParams {
  actualsRevenue: Nullable<number>
  planRevenue: Nullable<number>
}

export const calculateSalesPerformance = ({
  actualsRevenue,
  planRevenue,
}: ICalculateSalesPerformanceParams) => {
  if (!actualsRevenue || !planRevenue) {
    return null
  }

  return (actualsRevenue / planRevenue) * 100
}
